import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './newPages/login/login.component';
import { ChangePassComponent } from './newPages/change-pass/change-pass.component';
import { RegisterComponent } from './newPages/register/register.component';
import { CasosComponent } from './newPages/casos/casos.component';
import { FaqsComponent } from './newPages/faqs/faqs.component';
import { PerfilComponent } from './newPages/perfil/perfil.component';
import { ConfiguracionComponent } from './newPages/configuracion/configuracion.component';
import { NuevoCasoComponent } from './newPages/nuevo-caso/nuevo-caso.component';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { CasoDetailComponent } from './newPages/caso-detail/caso-detail.component';
import { SeguimientoComponent } from './newPages/seguimiento/seguimiento.component';
import { ActivateClientComponent } from './newPages/activate-client/activate-client.component';
import { CitasComponent } from './newPages/citas/citas.component';
import { AccesoSinRegistroComponent } from './newPages/acceso-sin-registro/acceso-sin-registro.component';
import { AvisoLegalComponent } from './newPages/aviso-legal/aviso-legal.component';
import { PoliticaPrivacidadComponent } from './newPages/politica-privacidad/politica-privacidad.component';
import { TerminosCondicionesAppComponent } from './newPages/terminos-condiciones-app/terminos-condiciones-app.component';
import { TerminosCondicionesWebComponent } from './newPages/terminos-condiciones-web/terminos-condiciones-web.component';
import { AccesoSinRegistroWebComponent } from './newPages/acceso-sin-registro-web/acceso-sin-registro.component';
import { CasoDetailWebComponent } from './newPages/caso-detail-web/caso-detail.component';
import { PoliticaCookiesComponent } from './newPages/politica-cookies/politica-cookies.component';
import { CasoVerifyComponent } from './newPages/caso-verify/caso-verify.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'acceso-sin-registro', component: AccesoSinRegistroComponent },
  { path: 'acceso-invitado', component: AccesoSinRegistroWebComponent },
  { path: 'change-pass/:id', component: ChangePassComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'aviso-legal', component: AvisoLegalComponent },
  { path: 'politica-privacidad', component: PoliticaPrivacidadComponent },
  { path: 'terminos-condiciones-app', component: TerminosCondicionesAppComponent },
  { path: 'terminos-condiciones-web', component: TerminosCondicionesWebComponent },
  { path: 'politica-cookies', component: PoliticaCookiesComponent },
  { path: 'activate-client', component: ActivateClientComponent },
  { path: 'casos', component: CasosComponent, canActivate: [AuthGuardService] },
  { path: 'citas', component: CitasComponent, canActivate: [AuthGuardService] },
  { path: 'nuevo-caso', component: NuevoCasoComponent, canActivate: [AuthGuardService] },
  { path: 'caso/:id', component: CasoDetailComponent, canActivate: [AuthGuardService] },
  { path: 'caso-web/:id', component: CasoDetailWebComponent },
  { path: 'seguimiento/:id', component: SeguimientoComponent },
  { path: 'faqs', component: FaqsComponent, canActivate: [AuthGuardService] },
  { path: 'perfil', component: PerfilComponent, canActivate: [AuthGuardService] },
  { path: 'configuracion', component: ConfiguracionComponent, canActivate: [AuthGuardService] },
  { path: 'caso-verify', component: CasoVerifyComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}